import React from "react";

export default function SendIcon() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="inherit">
      <g>
        <path fill="inherit" d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.438l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154V13z" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/chatbot/assets/send-icon.js